import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import ExpertScheduleProtection from './components/ExpertProtectionSchedule'

const ExpertScheduleProtectionPage = () => {
  return (
    <TopNavigationLayoutPageContent type='default'>
      <div className='inline-flex-gap' style={{ gap: '32px' }}>
        <h2 className='text--heading-h4' style={{ flexShrink: 0 }}>
          Расписание защит
        </h2>
      </div>
      <div>
        <ExpertScheduleProtection />
      </div>
    </TopNavigationLayoutPageContent>
  )
}

export default ExpertScheduleProtectionPage
